

























/* tslint:disable:no-console */
import { Component, Vue } from 'vue-property-decorator';

@Component({
  computed: {
    // arrow functions can make the code very succinct!
    stayLoggedIn: {
      get() {
        return this.$store.state.app.userSettings.stayLoggedIn;
      },
      set(val) {
        this.$store.commit('setUserSetting', { key: 'stayLoggedIn', val });
      },
    },
    denseRows: {
      get() {
        return this.$store.state.app.userSettings.denseRows;
      },
      set(val) {
        this.$store.commit('setUserSetting', { key: 'denseRows', val });
      },
    },
  },
  methods: {
    back() {
      window.history.back();
      console.log('TCL: back -> this.$router', this.$router);
    },
  },
})
export default class Settings extends Vue {}
